// src/App.js
import React, { useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import TokenPage from "./pages/TokenPage";
import Home from "./pages/Home";
import Staff from "./pages/Staff";
import Events from "./pages/Events";
import RequireAuth from "./routes/RequireAuth";
import AuthProvider, { AuthContext } from "./auth/AuthContext";

function AppRoutes() {
  const { isAuthed } = useContext(AuthContext);

  return (
    <>
      {isAuthed && <Header />}

      <Routes>
        {/* 토큰 입력(로컬 전용) */}
        <Route path="/token" element={<TokenPage />} />

        {/* 보호 라우트: 이제 홈이 루트('/') */}
        <Route element={<RequireAuth />}>
          <Route path="/" element={<Home />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/events" element={<Events />} />
        </Route>

        {/* 기타 주소 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}